define('fukit/configuration/evicommon.authentication.service.configuration',['require','exports','module','backbone','underscore','bluebird','backbone.radio','../config','../model/user.model','../model/person.model','../model/tenant.model','../lib/pendo.initializer'],function(require, exports, module) {
  //prettier-ignore
  var Backbone            = require('backbone'),
      _                   = require('underscore'),
      Promise             = require('bluebird'),
      Radio               = require('backbone.radio'),
      config              = require('../config'),
      UserModel           = require('../model/user.model'),
      PersonModel         = require('../model/person.model'),
      TenantModel         = require('../model/tenant.model'),
      PendoInitializer    = require('../lib/pendo.initializer');

  var EvicommonAuthenticationServiceConfiguration = {
    radioRequests: {
      'evicommon.authenticationServiceConfiguration options': 'options',
    },

    radioEvents: {
      'app configure': 'onAppConfigure',
      'evicommon.authenticationService basicAuthLoginSuccess': 'onBasicAuthLoginSuccess',
      'evicommon.authenticationService keycloakLoginSuccess': 'onKeycloakLoginSuccess',
    },

    onAppConfigure: function() {
      // we need to register the personPrincipalModel before anything happens because many views needing
      // to access personPrincipalModel are rendered prior to login success
      var personPrincipalModel = new PersonModel();

      Radio.request('AppKit.resourceService', 'registerResource', 'personPrincipalModel', personPrincipalModel);
    },

    // TODO: remove this function once the keycloak migration is complete
    onBasicAuthLoginSuccess: function(ctx) {
      if (!Radio.request('AppKit.resourceService', 'resource', 'tokenModel')) {
        Radio.request('AppKit.resourceService', 'registerResource', 'tokenModel', new Backbone.Model());
      }
      ctx.userPrincipalModel.set(ctx.userModel.attributes);
    },

    onKeycloakLoginSuccess: function(ctx) {
      //prettier-ignore
      var tokenModel = ctx.tokenModel,
          userPrincipalModel = ctx.userPrincipalModel;

      if (!Radio.request('AppKit.resourceService', 'resource', 'tokenModel')) {
        Radio.request('AppKit.resourceService', 'registerResource', 'tokenModel', tokenModel);
      }

      var userCollection = new UserModel.GroupsByUserCollection();
      var self = this;
      var userGroupArray = [];
      Promise.try(function() {
        userCollection.urlParams({
          userId: tokenModel.get('sub'),
        });
        return userCollection.fetch();
      }).then(function() {
        userGroupArray = _.map(userCollection.models, function(model) {
          return model.get('groupGroupName');
        });

        self.getTenantModel(tokenModel.get('tenantId')).then(function(tenantModel) {
          self.setUserPrincipalModel(userPrincipalModel, tokenModel, ctx, userGroupArray, tenantModel);
          self.setPersonPrincipalModel(userPrincipalModel);
        });
      });
    },

    setUserPrincipalModel: function(userPrincipalModel, tokenModel, ctx, userGroupArray, tenantModel) {
      userPrincipalModel.set({
        id: tokenModel.get('sub'),
        email: tokenModel.get('email'),
        username: tokenModel.get('preferred_username'),
        fullName: tokenModel.get('name'),
        name: tokenModel.get('name'),
        tenantId: tenantModel.get('id'),
        customerName: tenantModel.get('customerName'),
        accessToken: ctx.keycloakAuth.token,
        groups: userGroupArray,
      });
    },

    setPersonPrincipalModel: function(userPrincipalModel) {
      var personCollection = new PersonModel.Collection();
      var personPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'personPrincipalModel');
      personPrincipalModel.set('user', userPrincipalModel.toJSON());

      personCollection.filters.addFilterWithField({ name: 'userAccountId' }).equals(userPrincipalModel.id);

      return Promise.try(function() {
        return personCollection.fetch();
      }).then(function() {
        if (personCollection.length > 0) {
          personPrincipalModel.set(personCollection.models[0].toJSON());
        }
        pendoEnabled = config.get('pendo.enabled');
        if (pendoEnabled === true) {
          PendoInitializer.initialize(personPrincipalModel, userPrincipalModel.get('groups'));
        }
      });
    },

    getTenantModel: function(tenantId) {
      var tenantPrincipalModel = new TenantModel();

      tenantPrincipalModel.set('id', tenantId);
      return tenantPrincipalModel
        .fetch()
        .promise()
        .then(function() {
          return tenantPrincipalModel;
        });
    },

    options: function() {
      return {
        enabled: config.get('ENABLE_AUTHENTICATION'),
        storage: Radio.channel('storageConfiguration').request('storage'),
        userModelUsernameAttribute: 'username',
        sendDevHostHeader: !!config.get('evisions.auth.sendDevHostHeader'),
        sendRemoteUserHeader: !!config.get('evisions.auth.sendRemoteUserHeader'),
        sendBearerTokenHeader: !!config.get('evisions.auth.sendBearerTokenHeader'),
        keycloakConfig: config.get('keycloak.*'),
        authenticationConfig: config.get('authentication.*'),
        adminApiBaseUrl: config.get('admin.api.base.url'),
      };
    },
  };

  module.exports = EvicommonAuthenticationServiceConfiguration;
});

